import React from 'react';
import { Users } from 'lucide-react';
import RosterTab from './RosterTab';
import { useParticipant } from '../../hooks/useParticipant';
import { Loading } from './components';

// Top-level "Roster" page (the roster tab promoted out of the AI Adoption
// workspace for department heads). Individual drill-down only if the caller's
// capabilities allow it (audited server-side).
const RosterPage: React.FC = () => {
  const { context, ready } = useParticipant();
  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex items-center gap-2 mb-1">
        <Users size={22} className="text-brand-500" />
        <h1 className="text-2xl font-semibold text-gray-900">Roster</h1>
      </div>
      <p className="text-sm text-gray-500 mb-6">Who's enrolled and onboarded in your scope.</p>
      {!ready ? <Loading /> : <RosterTab canViewIndividual={!!context?.capabilities?.view_individual} />}
    </div>
  );
};

export default RosterPage;
